import React from "react";
import {Text, Pressable, SafeAreaView, ScrollView, StyleSheet, View} from "react-native";
import {SettingsItem} from "../component/SettingsItem";
import {useSelector} from "react-redux";
import '../function/i18n';
import {useTranslation} from 'react-i18next';
import {useTheme} from "@react-navigation/native";
import {LangItem} from "../component/LangItem";
import {ThemeItem} from "../component/ThemeItem";

export const ThemeScreen = () => {
    const settings = useSelector(state => state.settings);
    const themes = useSelector(state => state.themes);
    const {t, i18n} = useTranslation();
    const theme = useTheme();
    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            backgroundColor: theme.colors.scheme[3],
            alignItems: 'center',
            justifyContent: 'center',
        },
        list: {
            maxWidth: 800,
            flexGrow:1,
            padding: 8
        },
        settingsWrapper: {
            width:'100%',
            display:'flex',
            flexDirection:'row',
            flexWrap:'wrap'
        }
    });
    return(
        <SafeAreaView style={styles.container}>
            <ScrollView contentContainerStyle={[styles.list]}>
                <View style={styles.settingsWrapper}>
                {
                    themes.map((item, index) => {
                        return (<View key={index} style={{width:'100%'}}><ThemeItem theme={item} title={t('theme.list.'+item)}></ThemeItem></View>)
                    })
                }
                </View>
            </ScrollView>
        </SafeAreaView>
    )
}